
import { Component, Vue, Prop} from 'vue-property-decorator';

import * as SurveyVue from "survey-vue";
import * as surveyEnv from "@/components/survey/survey-glossary";
import surveyJson from "./forms/guardian-of-child.json";

import PageBase from "../../../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { togglePages } from '@/components/utils/TogglePages';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        PageBase
    }
})

export default class GuardianOfChild extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];      

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    survey = new SurveyVue.Model(surveyJson);
    surveyJsonCopy; 
    currentStep =0;
    currentPage =0;

    tableKey = 0;
    showTable = false;
    showPopup = false;
    showGuardianAssistance = false;
    tableError = false;

    applicationType=[]

    childrenNames = [];
    otherPartyNames = [];
    pageProgress = 0;   

    guardianOfChildItem =[
        {name:'', nameOther:'', date:'', relationship:''},
    ]
    
    guardianOfChildFields = [
        {key:"name",         label:"Name of Child",                                                                               tdClass:"align-middle", thClass:"text-primary align-middle text-center border-top-0", thStyle:"font-size:10pt; width:20%;"},
        {key:"nameOther",    label:"Name of Other Party (Guardian who you are applying to cancel their guardianship of a child)", tdClass:"align-middle", thClass:"text-primary align-middle text-center border-top-0", thStyle:"font-size:10pt; width:25%;"},
        {key:"date",         label:"When did the other party become a guardian of the child?",                                    tdClass:"align-middle", thClass:"text-primary align-middle text-center border-top-0", thStyle:"font-size:10pt; width:12%;"},
        {key:"relationship", label:"What is your guardianship relationship to the child?",                                        tdClass:"align-middle", thClass:"text-primary align-middle text-center border-top-0", thStyle:"font-size:10pt; width:18%;"},
        {key:"control",      label:"",                                                                                            tdClass:"align-middle", thClass:"text-primary align-middle text-center border-top-0", thStyle:"font-size:10pt; width:4%;"},
    ]

    beforeCreate() {
        const Survey = SurveyVue;
        surveyEnv.setCss(Survey);
    }

    mounted(){
        this.initializeSurvey();
        this.addSurveyListener();
        this.reloadPageInformation();
    }

    public initializeSurvey(){
        this.adjustSurveyForChildren();
        this.adjustSurveyForOtherParties();
        this.survey = new SurveyVue.Model(this.surveyJsonCopy);
        this.survey.commentPrefix = "Comment";
        this.survey.showQuestionNumbers = "off";
        this.survey.showNavigationButtons = false;
        surveyEnv.setGlossaryMarkdown(this.survey);
    }

    public adjustSurveyForChildren(){

        this.surveyJsonCopy = JSON.parse(JSON.stringify(surveyJson));         
        this.surveyJsonCopy.pages[0].elements[3].elements[0]["choices"]=[];        

        if (this.step.result?.childrenInfoSurvey) {
            const childData = this.step.result.childrenInfoSurvey.data; 
            this.childrenNames = [];       
            for (const child of childData){
                const childName = Vue.filter('getFullName')(child.name);
                this.childrenNames.push(childName)
                this.surveyJsonCopy.pages[0].elements[3].elements[0]["choices"].push(childName);                
            }
        }
    }

    public adjustSurveyForOtherParties(){
        const stepCOM = this.steps[this.stPgNo.COMMON._StepNo]

        if (stepCOM.result?.otherPartyCommonSurvey?.data) {
            const otherPartyData = stepCOM.result.otherPartyCommonSurvey.data;
            this.otherPartyNames = [];            
            for (const otherParty of otherPartyData){
                this.otherPartyNames.push(Vue.filter('getFullName')(otherParty.name))                
            }
        }
    }
    
    public addSurveyListener(){
        this.survey.onValueChanged.add((sender, options) => {
            Vue.filter('surveyChanged')('replyFlm')
            this.setPages();
            this.determineShowingTable();
           
            if((!this.applicationType || !this.applicationType?.includes("becomeGuardian")) && options.name == "applicationType" && options.value?.includes("becomeGuardian")){                
                this.showPopup = true; 

                //togglePages([this.stPgNo.RFLM.FlmAdditionalDocuments], true, this.currentStep);
                Vue.filter('requestRflmRequiredDocs')(this.currentPage, this.currentStep, true, 'counter');


                if(this.$store.state.Application.steps[this.currentStep].pages[this.stPgNo.RFLM.FlmAdditionalDocuments].progress==100)
                    Vue.filter('setSurveyProgress')(null, this.currentStep, this.stPgNo.RFLM.FlmAdditionalDocuments, 50, false);
            } 
            Vue.nextTick(()=> this.applicationType = this.survey.data.applicationType)
        })
    }

    public determineShowingTable(){
        if(this.survey.data?.applicationType?.includes('cancelGuardian'))
            this.showTable=true;
        else
            this.showTable=false;
    }

    public determineShowPopup(){
        if(this.survey.data?.applicationType?.includes('becomeGuardian'))
            return true;
        else
            return false;
    }
    
    public setPages(){ 
        if (this.survey.data?.applicationType?.includes("cancelGuardian")) {                
            togglePages([this.stPgNo.RFLM.GuardianOfChildBestInterestsOfChild], true, this.currentStep);                
        } else {
            togglePages([this.stPgNo.RFLM.GuardianOfChildBestInterestsOfChild], false, this.currentStep);
        }
        const RFLM = Vue.filter('isRFLM')()
        if(!this.survey.data?.applicationType?.includes("becomeGuardian") && Vue.filter('FLMform4Required')(RFLM)==false){
            //togglePages([this.stPgNo.RFLM.FlmAdditionalDocuments], false, this.currentStep);
            Vue.filter('requestRflmRequiredDocs')(this.currentPage, this.currentStep, false, 'counter');
        }
    }
    
    public reloadPageInformation() {

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        if (this.step.result?.guardianOfChildSurvey) {

            this.survey.data = this.step.result.guardianOfChildSurvey.data;
            this.applicationType = this.survey.data.applicationType
            if(this.survey.data?.cancelGuardianDetails) 
                this.guardianOfChildItem = this.survey.data.cancelGuardianDetails;

            Vue.filter('scrollToLocation')(this.$store.state.Application.scrollToLocationName);            
        }
        
        this.setPages();
        this.determineShowingTable();

        this.pageProgress = this.$store.state.Application.steps[this.currentStep].pages[this.currentPage].progress

        if(this.checkTableError())
            Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 50, true);        
        else
            Vue.filter('setSurveyProgress')(this.survey, this.currentStep, this.currentPage, 50, true);
    }

    public AddRow(){
        this.guardianOfChildItem.push({name:'', nameOther:'', date:'', relationship:''},)
    }

    public RemoveRow(){        
        if(this.guardianOfChildItem?.length>1)
            this.guardianOfChildItem.pop()
    }

    public checkTableError(){
        
        if(this.showTable)
            for(const itemIndex in this.guardianOfChildItem){
                const childItem = this.guardianOfChildItem[itemIndex]
                if(!childItem?.name || !childItem?.nameOther || !childItem?.date || !childItem?.relationship){
                    this.tableError = true;
                    return true
                }
            }
        this.tableError=false;
        return false
    }

    public tableChanged(){
        Vue.filter('surveyChanged')('replyFlm')
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        if(!this.survey.isCurrentPageHasErrors && !this.checkTableError()) {
            Vue.prototype.$UpdateGotoNextStepPage();
        }
    }  

    public closePopup(){
        this.showPopup = false;
    }
    
    beforeDestroy() {
        this.survey.setValue('cancelGuardianDetails', this.guardianOfChildItem)
        if(this.checkTableError())
            Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 50, true);        
        else
            Vue.filter('setSurveyProgress')(this.survey, this.currentStep, this.currentPage, 50, true);        

        const tableQuestion = this.showTable? {name:'cancelChildGuardianship', value: this.guardianOfChildItem, title:'Please complete the following information for each child you are applying for a person to no longer be a guardian of', inputType:''}: ''
        this.UpdateStepResultData({step:this.step, data: {guardianOfChildSurvey: Vue.filter('getSurveyResults')(this.survey, this.currentStep, this.currentPage, tableQuestion)}})
    }
}
